<script lang="ts">
  import { DirectusImage, Preset } from '@do/svelte-directus-images';

  import { AvatarPlaceholder } from '@shared/ui/avatar-placeholder';
  import { Container } from '@shared/ui/container';

  import type { ArtistType } from '@entities/artist';

  import ArtistStyles from './artist-styles.svelte';

  export let artist: ArtistType;

  const imgClass =
    'xs:w-[360px] xs:h-[360px] md:w-[400px] md:h-[400px] aspect-square lg:w-[416px] lg:h-[416px] object-cover rounded-lg';

  let image: HTMLImageElement;

  $: countries = artist.countries?.length ? artist.countries.map(({ country }) => country.value) : [];
</script>

<Container>
  <div class="mx-auto my-8 flex min-h-[360px] flex-col items-center justify-center gap-3">
    <div class="flex h-full w-full justify-center overflow-hidden rounded-lg">
      <DirectusImage
        imageData="{artist?.photo}"
        alt="{artist.name}"
        imgClasses="hover:scale-[103%] transition-transform duration-300 {imgClass}"
        loading="lazy"
        pictureSizes="{{
          default: '100vw',
          'min-1024': '800px',
          'min-1280': '840px',
        }}"
        presetKeys="{Preset.Thumbnail}"
        bind:imgElement="{image}"
      >
        <AvatarPlaceholder
          slot="default-placeholder"
          rounded="{false}"
          name="{artist.name}"
          classes="text-6xl {imgClass}"
        />
      </DirectusImage>
    </div>
  </div>

  <h1 class="text-4.5xl mb-10 text-center font-medium md:text-6xl">{artist.name}</h1>

  <div class="mx-auto mb-12 max-w-[648px]">
    <ArtistStyles
      fields="{artist.fields}"
      styles="{artist.styles}"
      socialProfiles="{artist.socialProfiles}"
      {countries}
      dateOfBirth="{artist.dateOfBirth}"
      dateOfDeath="{artist.dateOfDeath}"
    />
  </div>
</Container>
